import BadgeList from './BadgeList';
import EllipsisText from './EllipsisText';
import PageImage from './PageImage';
import SingleText from './SingleText';
import BlackBadgeListV4 from '../../commonSub/component/BlackBadgeListV4';
import RankingLabelV4 from '../../commonSub/component/RankingLabelV4';
import {IRankingInfo} from '../../home/common/type';
import useSplitAdultBadgeList from '../hook/useSplitAdultBadgeList';
import {IBadge} from '../type';

interface IProps {
  className?: string;
  title: string;
  titleImg: string;
  titleText?: string;
  description?: string;
  rankingInfo?: IRankingInfo;
  badgeListClassName?: string;
  badges: IBadge[];
  blackBadgeList?: string[];
}

export default function BigOverContentCardInfoV4({
  className,
  title,
  titleImg,
  titleText,
  description,
  rankingInfo,
  badgeListClassName,
  badges,
  blackBadgeList,
}: IProps) {
  const {adultBadges, otherBadges} = useSplitAdultBadgeList(badges);

  return (
    <div
      className={cn(
        'absolute inset-x-0 bottom-18 z-2',
        'flex-col flex-center text-center',
        className
      )}
    >
      {titleText && (
        <EllipsisText
          line={2}
          className={cn(
            'mx-auto text-center',
            's19-bold-white xs-max-320:text-[19px] xs:text-[21px] lg:text-[27px]',
            'xs-max-320:leading-22 xs:leading-24 lg:leading-32',
            'max-w-[280px] lg:max-w-[380px]'
          )}
        >
          {titleText}
        </EllipsisText>
      )}
      {!titleText && (
        <PageImage
          src={titleImg}
          className="mx-auto max-w-[140px] lg:max-w-[180px]"
          alt={title}
        />
      )}
      {description && (
        <SingleText className="s12-regular-white opacity-80 mt-6">
          {description}
        </SingleText>
      )}
      <div className="flex-center mt-12 gap-x-2">
        {rankingInfo && (
          <RankingLabelV4
            isBig
            ranking={rankingInfo.ranking}
            delta={rankingInfo.delta}
          />
        )}
        <BadgeList isBig badges={otherBadges} className={badgeListClassName} />
        <BlackBadgeListV4
          blackBadgeList={blackBadgeList}
          className={badgeListClassName}
        />
        <BadgeList isBig badges={adultBadges} className={badgeListClassName} />
      </div>
    </div>
  );
}
